export default "__VITE_ASSET__OAwN3noF__"